import React, { Component } from "react";
import { connect } from "react-redux";
import { Cache } from "aws-amplify";
import { Form, Row, Col, Button, Spinner, Modal } from "react-bootstrap";
import "../../css/login.css";
import t3Logo from "../../assets/finsi_logo.png";
import { Link } from "react-router-dom";
import {
  getCurrentUser,
  handleLoginFields,
  handleVerifyOtp,
  handleSendOtp,
  handleOtpField,
  loginUser,
  handleOTPcancel,
} from "../../store/actions/users/usersActions";

class Login extends Component {
  state = {
    showOtpModal: false,
    otp: "", // OTP as a single string
    resendTimer: 0,
    otpError: null,
  };

  componentDidMount() {
    const token = Cache.getItem("apiToken");
    const isOtpInProgress = localStorage.getItem("otpInProgress") === "true";

    if (isOtpInProgress) {
      // User has logged in, OTP is pending
      this.setState({ showOtpModal: true, resendTimer: 60 }, () => {
        this.startResendTimer();
      });
      return;
    }

    // Only proceed if OTP is not in progress
    if (token) {
      this.props.getCurrentUser(
        () => {
          this.props.history.push("/dashboard");
        },
        () => {
          Cache.removeItem("apiToken");
          this.props.history.push("/");
        }
      );
    }
  }

  // Start resend timer
  startResendTimer = () => {
    if (this.resendCountdown) clearInterval(this.resendCountdown);

    this.resendCountdown = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.resendCountdown);
          return { resendTimer: 0 };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
  };

  // Submit login and initiate OTP verification
  handleSubmit = (e) => {
    e.preventDefault();

    this.props.loginUser(() => {
      localStorage.setItem("otpInProgress", "true");
      this.props.handleSendOtp();
      this.setState({ showOtpModal: true, resendTimer: 60 }, () => {
        this.startResendTimer();
      });
    });
  };

  // Verify OTP
  handleVerifyOtp = (e) => {
    e.preventDefault();
    const enteredOtp = this.state.otp;

    // Check if OTP is valid
    if (!enteredOtp || enteredOtp.length !== 6) {
      this.setState({
        otpError: "Please enter a valid 6-digit OTP",
        otp: "",
      });
      return;
    }

    // Dispatch the OTP to Redux
    this.props.handleOtpField(enteredOtp);

    // Add a small delay to ensure Redux state is updated
    setTimeout(() => {
      // Dispatch verify OTP action
      this.props.handleVerifyOtp(
        () => {
          localStorage.setItem("handleVerifyOtp", "true");
          localStorage.removeItem("otpInProgress");

          const cachedToken = localStorage.getItem("cachedToken");
          if (cachedToken) {
            Cache.setItem("apiToken", cachedToken);
            localStorage.removeItem("cachedToken");
          }

          this.setState({ showOtpModal: false }, () => {
            // this.props.getCurrentUser(
            //   () => this.props.history.push("/dashboard"),
            //   () => {
            //     Cache.removeItem("apiToken");
            //     alert("Session expired. Please log in again.");
            //     this.props.history.push("/");
            //   }
            // );
          });
          this.props.history.push("/dashboard");
        },
        (error) => {
          // Error - Invalid OTP entered
          this.setState({
            otpError: "Invalid OTP. Please try again.",
            otp: "",
          });
        }
      );
    }, 100); // small delay to allow state update
  };

  // Handle OTP field change
  handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/, ""); // Only allow digits
    if (value.length > 6) return; // Ensure OTP length is 6 digits
    this.setState({ otp: value });
  };

  // Resend OTP
  handleResendOtp = () => {
    this.setState({ resendTimer: 60 }, () => {
      this.props.handleSendOtp();
      this.startResendTimer();
    });
  };

  // Cleanup when component unmounts
  componentWillUnmount() {
    if (this.resendCountdown) {
      clearInterval(this.resendCountdown);
    }
    localStorage.removeItem("otpInProgress");
  }

  render() {
    const apiToken = Cache.getItem("apiToken");
    const isLoggingIn = this.props.users.loggingIn;
    let loginValue = isLoggingIn ? (
      <Spinner animation="border" size="sm" />
    ) : (
      "Login"
    );

    return (
      <React.Fragment>
        {!this.state.showOtpModal && (
          <Row id="admin-page-login">
            <Col xs={12}>
              <img
                className="company-logo"
                src={t3Logo}
                alt="t3-logo"
                width="100%"
                height="auto"
              />
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="username">
                  <Form.Label id="company-lbl">Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Company Email"
                    onChange={(e) => this.props.handleLoginFields(e)}
                  />
                </Form.Group>

                <Form.Group controlId="password">
                  <Form.Label id="password-lbl">Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter Password"
                    onChange={(e) => this.props.handleLoginFields(e)}
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  id="t3-login-button"
                  size="sm"
                  block
                  type="submit"
                >
                  {loginValue}
                </Button>

                <Link
                  id="forgot-password-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push("/reset-password");
                  }}
                >
                  Forgot Password?
                </Link>

                <Link
                  id="resend-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.history.push("/resend-verification-code");
                  }}
                >
                  Resend Email Verification
                </Link>
              </Form>
            </Col>
          </Row>
        )}

        {/* OTP Modal */}
        <Modal
          show={this.state.showOtpModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Body>
            <Form.Group>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  margin: "20px 0 10px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "25px",
                    color: "#333",
                  }}
                >
                  Verification Code
                </span>
                <div>
                  <span style={{ fontSize: "13px", color: "#333" }}>
                    A verification code has been sent to your email
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "20px 0",
                }}
              >
                <Form.Control
                  type="text"
                  maxLength="6"
                  value={this.state.otp}
                  onChange={this.handleOtpChange}
                  style={{
                    width: "200px",
                    height: "40px",
                    textAlign: "center",
                    fontSize: "18px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    outline: "none",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
                  }}
                  placeholder="Enter 6-digit OTP"
                />
              </div>

              {this.state.otpError && (
                <div
                  style={{
                    color: "red",
                    textAlign: "center",
                    marginTop: "-15px",
                    fontSize: "12px",
                  }}
                >
                  {this.state.otpError}
                </div>
              )}

              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  marginTop: "20px",
                }}
              >
                Didn't receive the OTP verification code?
              </div>
              <div style={{ width: "100%", textAlign: "center" }}>
                {this.state.resendTimer > 0 ? (
                  <span style={{ fontSize: "13px", color: "#999" }}>
                    Resend OTP in {this.state.resendTimer}s
                  </span>
                ) : (
                  <span
                    onClick={this.handleResendOtp}
                    style={{
                      fontSize: "13px",
                      color: "#FFBA5C",
                      cursor: "pointer",
                    }}
                  >
                    Resend OTP Code
                  </span>
                )}
              </div>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                Cache.removeItem("apiToken");
                localStorage.removeItem("cachedToken");
                localStorage.removeItem("otpInProgress");
                this.setState({
                  showOtpModal: false,
                  otp: "",
                  otpError: null,
                });
                this.props.handleOTPcancel();
              }}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleVerifyOtp}>
              Verify
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    handleLoginFields: (...args) => dispatch(handleLoginFields(...args)),
    loginUser: (...args) => dispatch(loginUser(...args)),
    getCurrentUser: (...args) => dispatch(getCurrentUser(...args)),
    handleSendOtp: (...args) => dispatch(handleSendOtp(...args)),
    handleOtpField: (...args) => dispatch(handleOtpField(...args)),
    handleVerifyOtp: (...args) => dispatch(handleVerifyOtp(...args)),
    handleOTPcancel: (...args) => dispatch(handleOTPcancel(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
